/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Logo from "../Assets/logo.png";

import { HiOutlineBars3 } from "react-icons/hi2";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const menuOptions = [
    {
      text: "Acceuil",
      icon: <HomeIcon />,
      link: "/",
    },
    {
      text: "Qui sommes-nous ?",
      icon: <InfoIcon />,
      link: "#About",
    },
    {
      text: "Nos Services clés",
      icon: <CommentRoundedIcon />,
    },
    {
      text: "Contact",
      icon: <PhoneRoundedIcon />,
      link: "#ContactForm",
    },
  ];

  return (
    <nav className="flex items-center justify-between p-6 bg-[#080c1e]">
      {" "}
      {/* Updated background color */}
      <div className="flex items-center space-x-4">
        <img src={Logo} alt="Logo" className="ml-6 w-24 h-16" />{" "}
        {/* Adjust logo size */}
      </div>
      <div className="hidden md:flex md:mr-12 space-x-6 text-[#D0B070] text-lg font-medium font-sans">
        {" "}
        {/* Updated text color */}
        <a href="/" className="hover:text-[#B20000]">
          {" "}
          {/* Updated hover color */}
          Acceuil
        </a>
        <a href="#About" className="hover:text-[#B20000]">
          Qui sommes-nous ?
        </a>
        <a href="#Service" className="hover:text-[#B20000]">
          Nos Services clés
        </a>
        <a href="#ContactForm" className="hover:text-[#B20000]">
          Contact
        </a>
      </div>
      <div className="md:hidden text-white">
        <HiOutlineBars3
          onClick={() => setOpenMenu(true)}
          className="cursor-pointer text-2xl"
        />
      </div>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <List>
            {menuOptions.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component="a" href={item.link}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </nav>
  );
};

export default Navbar;
